import { render } from "./PayWithPoint.vue?vue&type=template&id=c3327b5a&scoped=true"
import script from "./PayWithPoint.vue?vue&type=script&lang=js"
export * from "./PayWithPoint.vue?vue&type=script&lang=js"

import "./PayWithPoint.vue?vue&type=style&index=0&id=c3327b5a&lang=scss"
import "./PayWithPoint.vue?vue&type=style&index=1&id=c3327b5a&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3327b5a"]])

export default __exports__